import React from "react";
import { Box, Heading, Button } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import DesignBackgroundEditorPage from "../editor/DesignBackgroundEditorPage";

export default function Step4Editor() {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) {
    return (
      <Box p={6}>
        <Heading size="md" mb={4}>
          Thiếu ID background
        </Heading>
        <Button colorScheme="blue" onClick={() => navigate("/design-background")}>
          Quay lại danh sách
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <DesignBackgroundEditorPage backgroundId={id} />
    </Box>
  );
}
